// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes indeterminate_first {
  0% {
    left: -100%;
    width: 100%;
  }
  100% {
    left: 100%;
    width: 10%;
  }
}

@keyframes indeterminate_second {
  0% {
    left: -150%;
    width: 100%;
  }
  100% {
    left: 100%;
    width: 10%;
  }
}

:root {
  --duration: 1.8s;
}

.loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}

.loader--fitToBottom .loader__line {
      margin: 0;
    }

.loader--fitToBottom .loader__text {
      width: 100%;
    }

.loader--fitToButtonBottom .loader__line {
      margin: 0;
      border-radius: 0 0 0.25rem 0.25rem;
    }

.loader--fitToButtonBottom .loader__text {
      width: 100%;
    }

.loader--collapse .loader__line {
      height: 0.25rem;
      margin: 0;
    }

.loader--collapse .loader__text {
      width: 100%;
    }

.loader--fullPage {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

.loader--loading {
    opacity: 1;
  }

.loader__line {
    display: block;
    width: 100%;
    height: 4px;
    margin: 20px auto;
    overflow: hidden;
    background-color: #93d0ff;
  }

.loader__text {
    flex: 1 1 auto;
    font-weight: 700;
  }

.loader__indeterminate {
    position: relative;
    width: 100%;
    height: 100%;
  }

.loader__indeterminate::before {
    position: absolute;
    height: 100%;
    content: '';
    background-color: #206dd2;
    animation: indeterminate_first 1.8s infinite ease-out;
  }

.loader__indeterminate::after {
    position: absolute;
    height: 100%;
    content: '';
    background-color: #206dd2;
    animation: indeterminate_second 1.8s infinite ease-in;
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
